<template>
  <div class="ma-5 pb-16">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ComponentWrapper',
};
</script>
